export enum LoadingKey {
  Page = 'page',
}
